import { ChangeDetectionStrategy, Component, Input, ViewChild, ElementRef } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { TlkLoadingSpinnerComponent } from '@itero/ui-toolkit-angular/loading-spinner';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { LabBrokerCommunicationService } from '../../services/lab-broker-communication.service';

@Component({
	selector: 'rx-lab-broker-iframe',
	templateUrl: './lab-broker-iframe.component.html',
	styleUrls: ['./lab-broker-iframe.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, AsyncPipe, TlkLoadingSpinnerComponent]
})
export class LabBrokerIframeComponent extends BaseDestroyableComponent {
	@ViewChild('iframeRef') private readonly iframeRef: ElementRef<HTMLIFrameElement>;

	private safeUrlInner: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(''); // NOSONAR typescript:S6268
	private lastUrlInner: string | null = null;

	@Input()
	set iframeUrl(value: string | null) {
		if (value === this.lastUrlInner) {
			return;
		}

		this.lastUrlInner = value;
		this.safeUrlInner = this.sanitizer.bypassSecurityTrustResourceUrl(value ?? ''); // NOSONAR typescript:S6268
	}

	get safeUrl(): SafeResourceUrl {
		return this.safeUrlInner;
	}

	get iframe(): HTMLIFrameElement {
		return this.iframeRef.nativeElement;
	}

	@Input() isLoading$: Observable<boolean> = of(false);

	constructor(
		private readonly communicationService: LabBrokerCommunicationService,
		private readonly sanitizer: DomSanitizer
	) {
		super();
	}
}
